import { Injectable, inject } from '@angular/core';
import { FirestoreItem } from '@scandium-oy/ngx-scandium';
import { of } from 'rxjs';
import { FirestoreService } from './firestore.service';

const itemCollection = 'ai-usage';

export interface AiUsage extends FirestoreItem {
  completion_tokens: number;
  prompt_tokens: number;
  total_tokens: number;
}

export interface AiUsageMonth {
  completion_tokens: number;
  prompt_tokens: number;
  total_tokens: number;
}

@Injectable({
  providedIn: 'root',
})
export class AiUsageService {
  private firestore = inject(FirestoreService);

  get(guid: string) {
    if (guid == null) {
      return of(null);
    }
    return this.firestore.get<AiUsage>(itemCollection, guid);
  }

  getList() {
    return this.firestore.getList<AiUsage>(itemCollection);
  }
}
